import { impactRatio, staggered } from '../sim/impact';
import { bossPartsLeft } from '../sim/boss-parts';
import { lockedTarget } from '../sim/lockon';
import { clearLock } from '../sim/lockon';
import { setAccum, setSimSteps } from '../game';
import { $ } from '../platform/dom';
import { boss } from '../entities/enemies';
import { elHpTxt, elLv, elOver, elPrompt, elRev, elRw, elShFill, elStageName, elThFill, elThTrack, elUp } from '../platform/dom';
import { dashCost, takeoffCost } from '../sim/flight';
import { clamp } from '../core/math';
import { RNG, newSeed, seedStr } from '../core/rng';
import { ETYPE } from '../entities/enemies';
import { MECHS } from '../entities/mechs';
import { accum, simSteps } from '../game';
import { SFX } from '../platform/audio';
import { elBoss, elHpFill, elKills, elStart, elTime, skillEls } from '../platform/dom';
import { applyParts, scrapReward } from '../sim/meta-parts';
import { recalcStats } from '../sim/stats';
import { META, checkUnlocks } from '../platform/storage';
import { STATE, shake, spawnDebris } from '../sim/fx';
import { clearWarnFx } from '../render/warn-fx';
import { clearCorpses } from '../render/enemy-field';
import { RUN_LEN, startRunFlow } from '../sim/stage-flow';
import { updateSlotsUI } from './levelup';
import { resetLevel, xpRatio } from '../sim/level';
import { resetLoadout, weaponById, weapons as loadWeapons, passives as loadPassives } from '../sim/loadout';
import { passiveById } from '../data/passives';
import { STAGES } from '../world/arena';
import { P, equipMech } from '../world/player';
import { closeHangar, openHangar } from './hangar';
import { openCodex } from './codex';
import { closePause, openPause, setPauseHandlers } from './screens/pause';
import { openSettings } from './screens/settings';
/* ============================================================
   HUD / 流程
   ============================================================ */
export var hudT = 0;
/** 上一次畫的等級。用來偵測「剛升級」那一幀（經驗條閃一下）。 */
var lastLv = 0;
export function showPrompt(t) { elPrompt.textContent = t; elPrompt.classList.toggle('show', !!t); }
export function banner(txt) {
  var el = $('banner'); el.textContent = txt;
  el.classList.remove('show'); void el.offsetWidth; el.classList.add('show');
}
/* 無線電：波次的一句旁白（M12）。

   分兩行是有分工的：`banner` 講「來的是什麼」（大字、一秒就消失），
   這一行講**「從哪個方位、要幹嘛」**——玩家要在預告的那 1.1 秒內
   做出「往哪邊走」的決定，而那個決定需要的是方位不是名字。
   順帶：它是這款遊戲目前唯一的敘事通道，語氣刻意寫成戰場無線電。 */
export function radio(txt) {
  var el = $('radio'); if (!el) return;
  el.textContent = txt;
  el.classList.remove('show'); void el.offsetWidth; el.classList.add('show');
}
export function updateHud(dt) {
  hudT += dt;
  /* **HUD 只在對局中出現。** 標題頁與任務簡報不再是一片不透明的遮罩
     （右半邊要看得到 3D 機體），所以 HUD 會直接露在標題底下 ——
     實看截圖上是「標題頁角落浮著血條與倒數」。用 body class 收起來，
     判準是 `STATE.running`：那正是「HUD 有意義」的定義。 */
  if (typeof document !== 'undefined' && document.body) {
    document.body.classList.toggle('run-on', !!STATE.running);
  }
  elHpFill.style.width = (P.hp / P.hpMax * 100) + '%';
  elShFill.style.width = (P.sh / P.shMax * 100) + '%';
  /* 分段刻度：**每格固定 25 點結構**，所以格數會隨結構上限成長 ——
     「被打掉幾格」因此是一個絕對的量，不用先知道上限才讀得懂。
     寫死格數的話，強化過上限之後刻度就在說謊。 */
  var hpSeg = $('hpSeg');
  /* `setProperty` 要防 undefined：headless 的假 DOM（`platform/dom.ts` 的 `stubEl`）
     的 `style` 只是一個空物件 —— 直接呼叫會在**所有模擬測試**裡炸掉
     （每一步都會走這裡），而症狀是「四條決定性測試同時紅」，離真因很遠。 */
  if (hpSeg && hpSeg.style && hpSeg.style.setProperty) {
    hpSeg.style.setProperty('--seg', (100 / Math.max(2, Math.round(P.hpMax / 25))) + '%');
  }
  /* 推進能量。`dry` 是「連起飛門檻都不到」——起不來的時候要看得出原因，
     否則玩家只會覺得按了沒反應（那是所有資源型能力最常見的抱怨）。 */
  if (elThFill) {
    var tm = P.s.thrustMax || 100;
    /* **填充量寫進 CSS 變數而不是直接寫 width/height**：三種 HUD 版型
       （`body.hud-a/b/c`）有的把能量條擺直、有的擺橫，由 CSS 決定填哪一軸。
       JS 只負責「現在剩幾 %」這一件它真正知道的事。 */
    var pct = (Math.max(0, P.thrust) / tm * 100) + '%';
    if (elThFill.style && elThFill.style.setProperty) elThFill.style.setProperty('--thr', pct);
    /* 三種狀態，玩家要分得出來：
         dry  連起飛門檻都不到（按了不會飛）
         low  連一次衝刺都衝不動（按了什麼都不會發生）
       `low` 是這一輪新增的 —— 衝刺併進能量之後，「按了沒反應」多了一種原因。 */
    if (elThTrack.classList) {
      elThTrack.classList.toggle('dry', P.thrust < takeoffCost());
      elThTrack.classList.toggle('low', P.thrust < dashCost());
    }
  }
  /* 衝刺不再有格數與冷卻：它問的是「能量夠不夠」（2026-08-06 併進推進能量）。
     `ready` 直接看 `dashCost()` —— 跟模擬用同一個來源，
     否則「鍵亮著但按了沒反應」是這類 UI 最常見的謊。 */
  var dc = dashCost();
  var tmax = P.s.thrustMax || 100;
  setSkill(skillEls.dash, P.thrust >= dc ? 1 : P.thrust / dc, '');
  /* 推進（長按起飛）也是一顆鍵：它跟衝刺吃同一條能量，只是門檻不同（40%）。
     沒有這顆的話「為什麼飛不起來」只能從一條細線推測。 */
  var fl: any = $('skFly'), flF: any = $('skFlyFill'), flN: any = $('skFlyN');
  if (fl && flF) {
    var tc = takeoffCost();
    var k = P.thrust >= tc ? 1 : P.thrust / tc;
    if (flF.style) flF.style.transform = 'scaleY(' + Math.max(0, Math.min(1, k)) + ')';
    if (fl.classList) fl.classList.toggle('ready', k >= 1);
    /* 飛行中用**狀態**表示（整顆鍵亮起＋底部脈動），不要印字 ——
       印「飛行中」會蓋掉「長按」那行鍵位（使用者 2026-08-06 實看指出）。 */
    if (fl.classList) fl.classList.toggle('active', P.y > P.gy + 0.35);
    if (flN) flN.textContent = '';
  }
  setSkill(skillEls.mid, 1 - Math.max(0, P.midCd) / P.s.midCdMax, P.midCd > 0 ? Math.ceil(P.midCd) : '');
  setSkill(skillEls.ult, 1 - Math.max(0, P.ultCd) / P.s.ultCdMax, P.ultCd > 0 ? Math.ceil(P.ultCd) : '');
  /* 鎖定目標面板：結構條 + 衝擊條。衝擊滿了就會踉蹌並大幅增傷，
     所以這條白色的進度是「還要打多久才開得了窗口」—— 集中火力的理由要看得見。 */
  var lt = lockedTarget();
  var lp = $('lockPanel');
  var bossUp = boss && boss.alive;
  /* 鎖到 Boss 時不顯示這個面板 —— Boss 血條已經有名稱、結構條、衝擊條，
     兩個疊在一起只是視覺噪音。鎖到別的目標時往下讓開 Boss 血條的位置。 */
  if (lt && lt === boss) {
    lp.classList.remove('show');
  } else if (lt) {
    lp.classList.add('show');
    lp.classList.toggle('low', !!bossUp);
    lp.classList.toggle('stag', staggered(lt));
    $('lockName').textContent = (lt.T.bn || lt.T.cn || lt.type) + (staggered(lt) ? '  · 踉蹌' : '');
    $('lockHp').style.width = Math.max(0, lt.hp / lt.hpMax * 100) + '%';
    /* 打不出踉蹌的目標（雜魚）直接把衝擊軌藏起來 ——
       一條永遠是 0% 的條看起來像壞掉，不如誠實說「不可踉蹌」。 */
    var canStag = lt.T.imp > 0;
    $('lockImpRow').style.display = canStag ? 'flex' : 'none';
    $('lockNote').style.display = canStag ? 'none' : 'block';
    if (canStag) {
      var ir = impactRatio(lt);
      $('lockImp').style.width = (ir * 100) + '%';
      $('lockImp').classList.toggle('near', ir > 0.75);
    }
  } else lp.classList.remove('show');

  if (hudT < 0.1) return;
  hudT = 0;
  var S = STAGES[STATE.stage];
  /* 20 分鐘倒數 —— 這是玩家唯一要看的數字（GDD §3.1）。
     舊版顯示的是「BOSS 抵達」的倒數，階段推進退場之後那個概念沒了。 */
  var left = Math.max(0, RUN_LEN - STATE.t);
  elTime.textContent = Math.floor(left / 60) + ':' + ('0' + Math.floor(left % 60)).slice(-2);
  $('timeLbl').textContent = '撤離倒數';
  elLv.textContent = String(P.lv);
  var xf = $('xpFill'); if (xf) xf.style.width = (xpRatio() * 100) + '%';
  /* 升級的那一下**整條經驗條閃一次**。經驗條移到畫面最上緣之後它同時是
     「你剛剛升級了」的畫面級回饋 —— 而升級選單會蓋住畫面，
     沒有這一下的話玩家只會看到選單「跳出來」，不知道是什麼觸發的。 */
  var xt = $('xpTrack');
  if (xt && P.lv !== lastLv) {
    lastLv = P.lv;
    xt.classList.remove('gain'); void (xt as any).offsetWidth; xt.classList.add('gain');
  }
  /* 最後一分鐘：倒數轉紅並脈動。這是這一場唯一的硬期限，
     而 20 分鐘裡它有 19 分鐘不重要 —— 只在重要的那一分鐘叫。 */
  var tp = $('top'); if (tp) tp.classList.toggle('urgent', left <= 60 && left > 0);
  elHpTxt.textContent = Math.ceil(P.hp) + ' / ' + P.hpMax + (P.sh > 0.5 ? '  +' + Math.ceil(P.sh) : '');
  /* 低耐久的邊緣警示。俯視鏡頭沒有「鏡頭語言」可用，
     所以「快死了」只能從畫面邊緣講（樣式在 styles/waves.css）。 */
  var vg = $('vignette');
  if (vg) {
    var hr = P.hp / P.hpMax;
    vg.classList.toggle('low', P.alive && hr < 0.34);
    vg.classList.toggle('crit', P.alive && hr < 0.14);
  }
  elKills.textContent = String(P.kills);
  elStageName.textContent = S.en;
  elRev.textContent = String(P.revives);
  if (boss && boss.alive) {
    elBoss.classList.add('show');
    $('bossFill').style.width = clamp(boss.hp / boss.hpMax, 0, 1) * 100 + '%';
    /* Boss 血條下面加一條衝擊條。Boss 是踉蹌最有意義的地方（上限 170–280、
       要持續輸出才填得滿），而 Boss 戰時這條血條一定在畫面上，不用先鎖定。 */
    var bir = impactRatio(boss);
    $('bossImp').style.width = (bir * 100) + '%';
    $('bossImp').classList.toggle('near', bir > 0.75);
    elBoss.classList.toggle('stag', staggered(boss));
    /* 名稱那一行同時是**狀態行**。四種狀態互斥，優先序照「玩家現在最需要
       知道哪一件」排：打不動（護盾／無敵）> 打得動（踉蹌）> 進度（階段）。

       ⚠️ 打不動的時候一定要講出理由。傷害數字跳「護盾」但血條不動、
       而 HUD 什麼都不說的話，玩家的結論會是「遊戲壞了」。 */
    var tag = '';
    if (boss.shield) tag = '　· 護盾（剩 ' + boss.adds + ' 隻）';
    else if (boss.invulnT > 0) tag = '　· 變形中';
    else if (staggered(boss)) tag = '　· 踉蹌';
    var st = boss.T.stages > 1 ? '　[' + (boss.stg + 1) + '/' + boss.T.stages + ']' : '';
    /* 還沒打掉的可破壞部位（規格 §5.2 只有 WALZE 與 ZENIT 有）。
       不列出來的話，那圈標記在畫面上只是一個沒有人解釋過的光環。 */
    var wp = bossPartsLeft(boss);
    var wt = wp > 0 ? '　· 弱點 ×' + wp : '';
    elBoss.classList.toggle('inv', !!(boss.shield || boss.invulnT > 0));
    $('bossName').textContent = boss.T.bn + st + tag + wt;
  }
  else elBoss.classList.remove('show');
}
export function setSkill(s, k, n) {
  s.fill.style.transform = 'scaleY(' + clamp(k, 0, 1) + ')';
  s.n.textContent = n === '' ? '' : n;
  s.root.classList.toggle('ready', k >= 1);
}

export function startRun(mechId, seed) {
  SFX.init();
  STATE.seed = seed >>> 0;
  RNG.seed(STATE.seed);
  equipMech(mechId);
  P.slashHits = []; P.dashAttack = false;
  P.scrap = 0; P.kills = 0;
  resetLoadout(); resetLevel();
  /* 新增任何模擬狀態欄位時，三個地方要一起改：這裡的重置、game.ts 的 snapshot()、
     以及該欄位的宣告初始值。漏掉 snapshot() 最危險 —— 測試會一直是綠的。
     已經踩過三次：P.faceAim/faceMove、P.barrel、STATE.timeScale。 */

  P.revives = META.revives; P.alive = true;
  P.iframe = 0; P.dashT = 0; P.shTimer = 0;
  P.fireCd = 0; P.midCd = 0; P.ultCd = 0; P.ultT = -1; P.swing = 0;
  P.combo = 0; P.comboT = 0; P.vortexSpin = 0; P.vortexBeat = 0; P.chestOffer = []; P.chestPicks = 0; P.chestTier = ''; P.bossUp = 0;
  /* 局外部件：先套 grant（結構／護盾／復活／衝刺／槽位／選項／主武裝改裝），
     再重算修正層。順序不能反 —— recalcStats 讀的是 P.base，而 grant 動的是
     上限與規則類的東西，兩者互不干擾但都要在開場結算完。 */
  applyParts(); recalcStats();
  STATE.runT = 0; STATE.over = false; STATE.won = false; STATE.paused = false;
  /* 頓幀的時間縮放也要歸一。damp 是指數趨近、永遠不會剛好等於 1，
     上一場結束時若還在頓幀中（大招的 hitstop 是 0.32），下一場就從那個值起跑，
     runT 會累積出微小的差額 —— 同種子的兩場因此跑不出相同結果。
     這是第三次踩到同一類問題（前兩次是 P.faceAim/faceMove 與 P.barrel）。

     規則：新增任何模擬狀態欄位時，三個地方要一起改 ——
     這裡的 startRun 重置、game.ts 的 snapshot()、以及該欄位的宣告初始值。
     漏掉 snapshot() 最危險，因為測試會一直是綠的。 */
  STATE.timeScale = 1; STATE.shake = 0; STATE.nearP = 0;
  // 上一場的地面預警不清掉的話會浮在新場地上（它們只吃自己的計時器）
  clearWarnFx();
  // 同理：上一場正在塌陷的屍體（純視覺，見 `render/enemy-field.ts`）
  clearCorpses();
  clearLock(); P.god = false;
  setSimSteps(0); setAccum(0);
  // 雙管交替的旗標。不重置的話，上一場射了奇數發時，下一場會從另一管開始 ——
  // 砲口橫向偏移 ±1.35 單位，邊緣命中判定跟著變，同種子的第二場就跑出不同結果。
  // 症狀是「兩種結果交替出現、週期 2」，這是找到它的線索。
  P.barrel = 0;
  STATE.reward = false;
  elStart.classList.remove('show'); elOver.classList.remove('show');
  elRw.classList.remove('show');
  updateSlotsUI();
  $('hudSeed').textContent = 'SEED ' + seedStr(STATE.seed);
  STATE.running = true;
  startRunFlow();
}
export function gameOver(win) {
  if (STATE.over) return;
  STATE.over = true; STATE.won = !!win; STATE.running = false; P.alive = false; STATE.phase = 'done';
  showPrompt('');
  if (P.rig) spawnDebris(P.pos.x, 2, P.pos.z, 0x8794a8, 24, 1.6, 0.4);
  if (!win) { SFX.boom(); shake(1.2); }
  META.kills += P.kills; META.runs++;
  if (win) META.wins++;
  /* 廢料收入。時間佔比高於擊殺 —— 撐下去比清場重要，
     否則玩家會學到「站在原地刷雜魚」而不是「往前推」。 */
  var earned = scrapReward(P.kills, STATE.t, win);
  META.scrap = (META.scrap || 0) + earned;
  META.bestStage = Math.max(META.bestStage, win ? STAGES.length : STATE.stage);
  var got = checkUnlocks();
  $('overTitle').textContent = win ? '任務達成' : '機體損毀';
  $('overTitle').className = win ? 'win' : '';
  /* 用 STATE.t（對局時鐘）而不是 runT（真實經過秒數）：兩者在正常遊玩時一致，
     但勝負判定與倒數 HUD 吃的都是 STATE.t，結束畫面跟著它才不會出現
     「倒數 0:00 但存活寫 0:13」這種自相矛盾的數字。 */
  var mm = Math.floor(STATE.t / 60), ss = Math.floor(STATE.t % 60);
  $('overStats').innerHTML =
    '<div><span>等級</span><b>' + P.lv + '</b></div>' +
    '<div><span>擊墜評分</span><b>' + P.kills + '</b></div>' +
    '<div><span>存活</span><b>' + mm + ':' + ('0' + ss).slice(-2) + ' / 20:00</b></div>';
  $('overBuild').innerHTML = buildSummary();
  $('overUnlock').innerHTML = got.length ? '<div class="unlock">解鎖：' + got.join('、') + '</div>' : '';
  $('overSeed').textContent = 'SEED ' + seedStr(STATE.seed);
  setTimeout(function () { elOver.classList.add('show'); }, 700);
}
/** 結束畫面的 build 組成。玩家死掉時最想知道的是「我這場走了什麼路線」。 */
function buildSummary() {
  var out = '', i;
  for (i = 0; i < loadWeapons.length; i++) {
    var w = weaponById(loadWeapons[i].id);
    out += '<span class="bchip wpn">' + (w ? w.n : loadWeapons[i].id) + ' <b>' + loadWeapons[i].lv + '</b></span>';
  }
  for (i = 0; i < loadPassives.length; i++) {
    var p = passiveById(loadPassives[i].id);
    out += '<span class="bchip">' + (p ? p.n : loadPassives[i].id) + ' <b>' + loadPassives[i].lv + '</b></span>';
  }
  return out || '<span class="bchip">未取得任何強化</span>';
}

/* 暫停 ＝ 打開作戰狀態面板（`ui/screens/pause.ts`）。
   在這之前只丟一個「暫停」橫幅，而戰場連暗都不暗 —— 實看截圖上那個狀態
   看起來像當機。`STATE.paused` 仍然只在這一個地方翻，面板不自己動它。 */
export function togglePause() {
  STATE.paused = !STATE.paused;
  if (!STATE.paused) { closePause(); return; }
  setPauseHandlers({
    resume: function () { STATE.paused = false; closePause(); },
    settings: function () { closePause(); openSettings('screenPause'); },
    /* 放棄作戰＝當場結算。走 `gameOver(false)` 而不是丟回標題頁：
       這一場的統計與 build 摘要仍然該給玩家看，那是「再一場」的鉤子。 */
    quit: function () { closePause(); STATE.paused = false; gameOver(false); }
  });
  openPause();
}

/* 開始畫面、任務簡報、設定的導覽整組搬到 `ui/screens/`（2026-08-05）——
   這個檔只留對局中的 HUD 與流程（startRun / gameOver）。 */
